/* eslint-disable @typescript-eslint/no-explicit-any */
import {useEffect, useState} from 'react';
import { defaultValues, showErrorValuesDefault, showErrorValuesSubmit } from '../../data/constants/demanderRDV';
import { IError } from '../../data/types/interface/demanderRDV';
import { thousandSeparator } from '../../data/factory';

export const useForm = (
  data: any,
  Validate: any,
  handleCancel: any,
  handleSave: any,
  listAgence?: any,
  prime?: any,
) => {
  const [values, setValues] = useState(data);
  const [dto, setDto] = useState({error: true, data});
  const [showErrors, setShowErrors] = useState(showErrorValuesDefault);
  const [errors, setErrors] = useState<IError>(defaultValues);

  const handleChange = (name: string, value: any, fired: boolean) => {
    setShowErrors({...showErrors, [name]: value !== fired});
    let primeTTC = '';
    if (name === 'dateNaissanceEleveAssure') {
      const _agePortal = 12;
      const minDate = new Date();
      minDate.setFullYear(new Date().getFullYear() - _agePortal);

      if (value > minDate) {
        primeTTC = thousandSeparator(prime.moinsDouze, ' ');
      } else {
        primeTTC = thousandSeparator(prime.plusDouze, ' ');
      }
    }
    setValues({
      ...values,
      [name]: value,
      primeTTC: primeTTC !== '' ? primeTTC : values.primeTTC,
    });
  };

  const noError = () => {
    let bNoError = true;
    Object.values(errors).forEach(element => {
      if (element !== '') {
        bNoError = false;
      }
    });
    return bNoError;
  };

  const handleSubmit = () => {
    setShowErrors(showErrorValuesSubmit);
    setErrors(Validate(values, listAgence));
    if (noError()) {
      setDto({error: false, data: values});
    } else {
      setDto({error: true, data: {}});
    }
  };
  const cancel = () => {
    handleCancel();
  };

  useEffect(() => {
    setErrors(Validate(values, listAgence));
  }, [values]);

  useEffect(() => {
    if (!dto.error) {
      handleSave();
    }
  }, [dto]);

  return {handleChange, handleSubmit, values, errors, showErrors, dto, cancel};
};
